var _taggedTemplateLiteral = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SHIPPING_RATES = exports.GET_CHECKOUT = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var checkoutFragment_1 = require("../fragments/checkoutFragment");

exports.GET_CHECKOUT = (0, graphql_tag_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GET_CHECKOUT($countryCode: CountryCode!, $checkoutId: ID!) @inContext(country: $countryCode) {\n    node(id: $checkoutId) {\n      ... on Checkout {\n        ...CheckoutFragment\n      }\n    }\n  }\n  ", "\n"])), checkoutFragment_1.CHECKOUT_FRAGMENT);
exports.GET_SHIPPING_RATES = (0, graphql_tag_1.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query GET_SHIPPING_RATES($countryCode: CountryCode!, $id: ID!) @inContext(country: $countryCode) {\n    node(id: $id) {\n      ... on Checkout {\n        ...CheckoutFragment\n        availableShippingRates {\n          ready\n          shippingRates {\n            handle\n            priceV2 {\n              amount\n              currencyCode\n            }\n            title\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), checkoutFragment_1.CHECKOUT_FRAGMENT);